"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NftBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _variables = require("@blockwell/variables");
const settings = [{
  title: "NFT Item",
  settings: _variables.NftVariable.settings
}, {
  title: "Metadata",
  settings: {
    variable: {
      type: "def",
      title: "Metadata Variable",
      description: "Save NFT item metadata to a variable.",
      default: {
        name: "metadata"
      }
    }
  }
}, {
  title: "Display",
  settings: {
    layout: {
      type: "select",
      title: "Item Style",
      description: "Name of the style to display the item with.",
      enum: ["card", "mini"],
      default: "card"
    }
  }
}];
class NftBlock extends _BlockType.BlockType {
  constructor(param, variableTypes) {
    super();
    (0, _defineProperty2.default)(this, "type", "nft");
    (0, _defineProperty2.default)(this, "nftVariable", void 0);
    (0, _defineProperty2.default)(this, "layoutVariable", void 0);
    this.param = param;
    this.nftVariable = this.addBlockVariable(variableTypes.get("nft"), param, ["tokenId", "contract"], {
      key: "variable",
      default: "metadata"
    });
    this.layoutVariable = this.addBlockVariable(variableTypes.get("literal"), param, [["layout", "value"]]);
  }
  renderValue() {
    let value = this.nftVariable.value();
    let layout = _variables.vals.stringValue(this.layoutVariable.value()) || "card";
    return {
      value: (0, _variables.isNftValueType)(value) ? _variables.vals.value(value) : null,
      layout
    };
  }
}
exports.NftBlock = NftBlock;
(0, _defineProperty2.default)(NftBlock, "settings", settings);
//# sourceMappingURL=NftBlock.js.map